import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import CategoryActions from '../../Redux/CategoryRedux'
import CreateCategory from '../../Containers/Ecommerce/CreateCategory'
import UpdateCategoryName from '../../Containers/Ecommerce/UpdateCategoryName'
import UpdateCategoryImage from '../../Containers/Ecommerce/UpdateCategoryImage'

class ManageCategory extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  _fetchCategory = (event) => {
    if (event) { event.preventDefault() }
    let filter = ''
    this.props.getCategory(filter)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => { this._fetchCategory() }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchCategory()
    }
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  componentDidMount = () => {
    this._fetchCategory()
  }

  render () {
    const { category } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Category
              {
                (category.fetching || category.processing) &&
                <div className='badge badge-info ml-2'>{ category.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-category')}>
              Create Category
            </button>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(category.fetching || category.processing) && category.err &&
              <div className='alert alert-danger'>{category.err}</div>
            }
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center'>Category Name</th>
                  <th className='text-center'>Icon</th>
                  <th className='text-center'>Image</th>
                  <th className='text-center'>Edit Category</th>
                </tr>
              </thead>
              <tbody>
                {
                  !category.data || !category.data.length
                    ? <tr>
                      <td colSpan='6' className='text-center'>No data</td>
                    </tr>
                    : category.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center align-middle'>{ item.name }</td>
                        <td className='text-center'>
                          {
                            item.icon_url
                              ? <img src={item.icon_url} alt='' style={{ height: '75px' }} />
                              : 'Empty'
                          }
                        </td>
                        <td className='text-center'>
                          {
                            item.image_url
                              ? <img src={item.image_url} alt='' style={{ height: '75px' }} />
                              : 'Empty'
                          }
                        </td>
                        <td className='text-center d-flex justify-content-around'>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'update-category-name')} >
                            <i className='fa fa-edit' /> Name
                          </button>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'update-category-image')} >
                            <i className='fa fa-edit' /> Image
                          </button>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </section>
        <section>
          {
            (category.data && category.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={category.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={category.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-category'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateCategory closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-category-name'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateCategoryName detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-category-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateCategoryImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  category: state.category
})

const dispatchToProps = (dispatch) => ({
  getCategory: (filter) => dispatch(CategoryActions.getCategoryRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(ManageCategory)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageCategory.js